module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAfElEQVR4AWMYNOA/OlZkZvtvz8YNwmA2NjVYDWAG4hB2/v8ZnML/g4E0CKcD2SAxZmIM8GLj+5/GIfy/mFP0/wEBZRAGsUFiIDn8BrAwMP73BCoyZ+H6P5VHBoiloVgGJAaSA6nBNOCcoNp/MvBgMsB4nul/MvCwMGB4AADwjApFkTkVxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MW.png
// module id = 1219
// module chunks = 0